import { combineReducers } from 'redux';
import params from './params';
import data from './data';
import fundData from './fundData';

const rootReducer = combineReducers({
  params,
  data,
  fundData,
});

export default rootReducer;
